import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import { CarouselServices } from "../../components/carouselServices";
import { BreakAttach } from "../../components/breakAttach";
import { SubservicesTabs } from "../../components/subservicesTabs/subservicesTabs";
import bgStreamingHead from "../../assets/imgs/servicios/streaming/bg_streaming_head.png";
import bgStreamingContent from "../../assets/imgs/servicios/streaming/str05.jpg";
import { useTranslation } from "react-i18next";
import { Gallery } from "../../components/gallery/gallery";

import ico01 from "../../assets/imgs/servicios/streaming/1.jpg";
import ico02 from "../../assets/imgs/servicios/streaming/2.jpg";
import ico03 from "../../assets/imgs/servicios/streaming/3.jpg";
import ico04 from "../../assets/imgs/servicios/streaming/4.jpg";
import ico05 from "../../assets/imgs/servicios/streaming/5.jpg";
import ico06 from "../../assets/imgs/servicios/streaming/6.jpg";
export const galleryStreaming = [ico01, ico02, ico03, ico04, ico05, ico06];

export const StreamingPage = () => {
  useEffect(() => {
    const scrollToTop = () => {
      window.scrollTo(0, 0);
    };
    scrollToTop();
  });
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>Streaming - JC Innovation</title>
      </Helmet>
      <section className="wrapper__page_services">
        <div className="contain__head_page">
          <div className="container-lg">
            <div className="row align-items-center">
              <div className="col-md-6">
                <div className="sec_head container_am">
                  <h3 className="ttls ttl_section c_morado mb-2 mb-4">
                    {t("Streaming")}
                  </h3>
                  <p className="paragraph lg">
                    {t(
                      "Nuestra solución es completa y ofrecemos toda nuestra experiencia y equipo de producción para lograr transmitir tu evento a la mayor cantidad de usuarios con la mejor calidad."
                    )}
                  </p>
                  <div className="mt-5 text-start">
                    <div className="row">
                      <div className="col-md-6">
                        <p className="paragraph sm">
                          <i className="fa-solid c_primary fa-plus"></i>{" "}
                          {t("Ponencias en vivo.")}
                        </p>
                      </div>

                      <div className="col-md-6">
                        <p className="paragraph sm">
                          <i className="fa-solid c_primary fa-plus"></i>{" "}
                          {t("Cogresos")}
                        </p>
                      </div>
                      <div className="col-md-6">
                        <p className="paragraph sm">
                          <i className="fa-solid c_primary fa-plus"></i>{" "}
                          {t("Ferias y Paneles")}
                        </p>
                      </div>
                      <div className="col-md-6">
                        <p className="paragraph sm">
                          <i className="fa-solid c_primary fa-plus"></i>{" "}
                          {t("Webinars y eventos digitales")}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="text-center">
                  <img src={bgStreamingHead} alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container-lg">
          <h4 className="mt-5 text-lg text-center fw_700 ">
            <span className="c_morado">{t("Tú haces tus contenidos,")}</span>{" "}
            {t(" nosotros todo lo demás.")}
          </h4>
        </div>

        <div className="contain_info__page ">
          <div className="container-lg">
            <div className="row align-items-center justify-content-center">
              <div className="col-md-4">
                {" "}
                <div className="con_img_info">
                  <img src={bgStreamingContent} alt="Streaming" />
                </div>
              </div>
              <div className="col-md-4">
                <div className="col_info">
                  <h3 className="fw_600 ">
                    {t("Todo lo que tu transmisión necesita.")}
                  </h3>
                  <p className="paragraph sm">
                    {t(
                      "Relaciónate en un ambiente digital totalmente inmersivo y realiza actividades como en un congreso presencial."
                    )}
                  </p>
                  <p className="paragraph sm mb-5">
                    <span className="c_morado fw_600">
                      {t(
                        "Cada transmisión que haces pone sobre la mesa la reputación de tu marca,"
                      )}
                    </span>{" "}
                    {t(
                      "el compromiso con tu audiencia y los resultados de tu compañía."
                    )}
                  </p>
                  <hr />
                  <p className="paragraph sm fw_500">
                    <span>
                      <i className="c_primary fa-solid fa-plus"></i>
                    </span>{" "}
                    {t("Mensajes en vivo.")}
                  </p>
                  <p className="paragraph sm fw_500">
                    <span>
                      <i className="c_primary fa-solid fa-plus"></i>
                    </span>{" "}
                    {t("100% personalizable.")}
                  </p>
                  <p className="paragraph sm fw_500">
                    <span>
                      <i className="c_primary fa-solid fa-plus"></i>
                    </span>{" "}
                    {t("Duración indefinida.")}
                  </p>
                  <p className="paragraph sm fw_500">
                    <span>
                      <i className="c_primary fa-solid fa-plus"></i>
                    </span>{" "}
                    {t("Interacción en vivo.")}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <SubservicesTabs />
        <Gallery images={galleryStreaming} title="Streaming" />
      </section>
    </>
  );
};
